export enum TWOFA_TYPE {
    SMS=1,
    EMAIL=2
}
